// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__BCh7K","requiredAsterisk":"Info_requiredAsterisk__kOAXd"};